import { variableValidator } from './common'

/**
 * Catch everything inside the brackets and ensure it's copied into the translation
 */
const regExp = new RegExp('{.*?}', 'g')
export default variableValidator(regExp)
